import React, { useState, useEffect } from 'react'

import { getQuery } from 'provider/queries/customQueryFormatter'
import { countSummaryQuery } from 'provider/queries/hasuraQueries'
import qs from 'query-string'
import { Error, List, useQuery, useTranslate } from 'react-admin'
import { useLocation } from 'react-router-dom'
import { post as getFromHasura } from 'utils/axios'

import { InvoiceActions } from '../actions/invoiceActions'
import { InvoiceTabbedDatagrid } from '../datagrids/invoiceTabbedDatagrid'
import { CreateInvoiceDialog } from '../dialogs/createInvoiceDialog'
import { Pagination } from './pagination'
import { RefreshPanel, RefreshItem } from './refreshContent'
import PanelHeader from 'components/PanelHeader'

const FILTER_DEFAULT_VALUES = { tabName: 'advanced' }

const SORT = {
  field: 'requested_at',
  order: 'DESC',
}

const SORT_CREDIT_LINES = {
  field: 'buyer',
  order: 'ASC',
}

const InvoicePagination = (props) => {
  return <Pagination {...props} rowsPerPageOptions={[10, 25, 50, 100]} />
}

export const InvoiceList = (props) => {
  return <InvoiceListCore {...props} />
}

export const InvoiceListCore = ({ className, ...props }) => {
  const translate = useTranslate()
  const [showExport, setShowExport] = useState(false)
  const [tabsCount, setTabsCount] = useState(null)
  const [statusError, setStatusError] = useState()
  const location = useLocation()
  const queries = qs.parse(location?.search)

  const { data: creditLines, error } = useQuery({
    type: 'getList',
    resource: 'creditlines',
    payload: {
      pagination: { page: 1, perPage: 10000 },
      sort: SORT_CREDIT_LINES,
    },
  })

  function transformCountData(payload) {
    const { advancedCount, lateCount, paidCount, delayedCount } = payload.data
    return {
      advanced: advancedCount?.aggregate.count,
      paid: paidCount?.aggregate.count,
      late: lateCount?.aggregate.count,
      delayed: delayedCount?.aggregate.count,
    }
  }

  function fetchCount() {
    try {
      let invoiceCount = getFromHasura({
        payload: countSummaryQuery,
      })

      invoiceCount.then((res) => setTabsCount(transformCountData(res)))
    } catch (error) {
      console.error(error)
      setStatusError(true)
    }
  }

  useEffect(() => {
    if (!tabsCount) {
      fetchCount()
    }
  }, [fetchCount, tabsCount])

  if (statusError) return <Error error={error} />

  const handleChangeList = ({ total, loading }) => {
    setShowExport(!loading && total > 0)
  }

  const hasuraQueryFilter = () => {
    const filter = queries.filter
    let parsedFilter
    if (filter) {
      parsedFilter = JSON.parse(queries.filter).tabName
    } else {
      parsedFilter = 'advanced'
    }

    return getQuery([
      {
        name: 'INVOICE_TAB',
        values: {
          state: parsedFilter,
        },
      },
    ])
  }

  return (
    <>
      <PanelHeader title={translate('resources.invoices.name')} />
      <RefreshPanel>
        <RefreshItem>
          <List
            className={className}
            {...props}
            bulkActionButtons={false}
            pagination={<InvoicePagination />}
            title={translate('resources.invoices.name')}
            actions={
              <InvoiceActions
                linkDataCreditLines={creditLines}
                {...props}
                showExport={showExport}
              />
            }
            sort={SORT}
            filterDefaultValues={FILTER_DEFAULT_VALUES}
            filter={hasuraQueryFilter()}
          >
            <InvoiceTabbedDatagrid
              linkDataCreditLines={creditLines}
              invoiceCount={tabsCount}
              onChangeList={handleChangeList}
            />
          </List>
        </RefreshItem>
        <CreateInvoiceDialog
          {...props}
          onCountRefresh={fetchCount}
          tabsCount={tabsCount}
        />
      </RefreshPanel>
    </>
  )
}
